export default __webpack_public_path__ + "static/Wingspans-homepage-portfolio-8e0f539509b4b83024096292f4616b02.jpg";